<div class="row section">
    <div class="col-md-5 hidden-sm hidden-xs img-vayetek">
    </div>
    <div class="col-md-7 right">
        <router-outlet></router-outlet>
    </div>
</div>
